import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Switch, Card, Row, Col, Button, Spin, message, Icon } from 'antd'

import LangContext from 'modules/shared/context/langContext'
import { GeneralStyledContent } from '../../../../styled/common-styled'
import Breadcrumb from '../../../shared/components/Breadcrumb'
import * as actions from '../actions'

const EVENT_TYPES = [
  {
    key: 'sound',
    color: '#1890FF',
    icon: 'sound',
    getLabel: i18n => i18n.n.notificationSound,
  },
  {
    key: 'parking',
    color: '#c91c1c',
    icon: 'environment',
    getLabel: i18n => i18n.p.parkingOnRoadSide,
  },
  {
    key: 'speed_over',
    color: '#00BF06',
    icon: 'dashboard',
    getLabel: i18n => i18n.s.speedOverLimit,
  },
  {
    key: 'driving_4hr',
    color: '#ffd619',
    icon: 'clock-circle',
    getLabel: i18n => i18n.d.driveContinuouslyForMoreThan4Hours,
  },
  {
    key: 'driving_10hr',
    color: '#848484',
    icon: 'hourglass',
    getLabel: i18n => i18n.d.driveContinuouslyForMoreThan10HoursDay,
  },
  {
    key: 'aggressive',
    color: '#722ed1',
    icon: 'warning',
    getLabel: i18n => i18n.a.aggressiveAccelerationAndImmediatelyBreak,
  },
]

class NotificationSetting extends Component {
  state = {
    localSettings: null,
  }

  componentDidMount() {
    this.props.loadNotificationSetting({
      accessToken: this.props.accessToken,
    })
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.notificationSettingState.loading &&
      !this.props.notificationSettingState.loading &&
      this.state.localSettings === null
    ) {
      this.setState({
        localSettings: { ...this.props.notificationSettingState.settings },
      })
    }
  }

  handleToggle = (key, checked) => {
    this.setState(prev => ({
      localSettings: {
        ...prev.localSettings,
        [key]: checked,
      },
    }))
  }

  handleSave = () => {
    this.props.saveNotificationSetting(
      {
        accessToken: this.props.accessToken,
        settings: this.state.localSettings,
      },
      () => {
        message.success('บันทึกสำเร็จ')
      },
    )
  }

  render() {
    const { loading, saving } = this.props.notificationSettingState
    const { localSettings } = this.state

    return (
      <LangContext.Consumer>
        {i18n => (
          <GeneralStyledContent>
            <Breadcrumb
              match={this.props.match}
              style={{ margin: '0px 0px 14px 10px' }}
            />
            <Spin spinning={loading}>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Card
                  title={
                    <span>
                      <Icon
                        type="bell"
                        style={{ marginRight: 8, color: '#1890FF' }}
                      />
                      {i18n.n.notification} - {i18n.s.setting || 'ตั้งค่า'}
                    </span>
                  }
                  style={{ width: '100%' }}
                >
                  <p style={{ color: '#999', marginBottom: 16, fontSize: 13 }}>
                    <LangContext.Consumer>
                      {i18n => i18n.s.selectEventTypeForNotification}
                    </LangContext.Consumer>
                  </p>
                  {EVENT_TYPES.map(eventType => (
                    <Row
                      key={eventType.key}
                      type="flex"
                      align="middle"
                      style={{
                        padding: '12px 0',
                        borderBottom: '1px solid #f0f0f0',
                        ...eventType.rowStyle,
                      }}
                    >
                      <Col span={2}>
                        <Icon
                          type={eventType.icon}
                          style={{ color: eventType.color, fontSize: 18 }}
                        />
                      </Col>
                      <Col span={18}>
                        <span style={{ fontSize: 14, ...eventType.labelStyle }}>
                          {eventType.getLabel(i18n)}
                        </span>
                      </Col>
                      <Col span={4} style={{ textAlign: 'right' }}>
                        <Switch
                          checked={
                            localSettings
                              ? !!localSettings[eventType.key]
                              : true
                          }
                          onChange={checked =>
                            this.handleToggle(eventType.key, checked)
                          }
                        />
                      </Col>
                    </Row>
                  ))}

                  <div style={{ marginTop: 24, textAlign: 'right' }}>
                    <Button
                      type="primary"
                      loading={saving}
                      onClick={this.handleSave}
                      disabled={!localSettings}
                    >
                      {i18n.s.save}
                    </Button>
                  </div>
                </Card>
              </div>
            </Spin>
          </GeneralStyledContent>
        )}
      </LangContext.Consumer>
    )
  }
}

const mapStateToProps = ({
  auth: { accessToken },
  notificationSettingState,
}) => ({
  accessToken,
  notificationSettingState,
})

const mapDispatchToProps = {
  loadNotificationSetting: actions.loadNotificationSetting.request,
  saveNotificationSetting: actions.saveNotificationSetting.request,
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationSetting)
